import { render } from "./ExpertStatisticsOutboundAnswered.vue?vue&type=template&id=3dd4d5d2"
import script from "./ExpertStatisticsOutboundAnswered.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsOutboundAnswered.vue?vue&type=script&lang=js"

import "./ExpertStatisticsOutboundAnswered.vue?vue&type=style&index=0&id=3dd4d5d2&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__